import BarChartIcon from '@mui/icons-material/BarChart';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import DeleteIcon from '@mui/icons-material/Delete';
import DocumentScannerIcon from '@mui/icons-material/DocumentScanner';
import { Box, Card, CardContent, IconButton,Tooltip, Typography } from '@mui/material';
import Link from 'next/link';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import ResultField from '@/features/components/Inputfields/ResultTextField';
import { HtmlTooltip } from '@/features/components/ToolTip';
import {
  countWords,
  gotoLogin,
  handleCopy,
  handleDelete,
  handlePerformance
} from '@/features/Functions/ResultFunctions';
import CrownIcon from '@/features/Icons/CrownIcon';

interface ResponseCardProps {
  response: string;
  index: number;
  responses: string[];
  setResponses: React.Dispatch<React.SetStateAction<string[]>>;
  handleCopy: (text: string) => void;
  handleDelete: (index: number, responses: string[], setResponses: React.Dispatch<React.SetStateAction<string[]>>) => void;
  handlePerformance: (text: string) => void;
  premium: boolean;
}

const ResponseCardPlagiarism: React.FC<ResponseCardProps> = ({
                                                     response,
                                                     index,
                                                     responses,
                                                     setResponses,
                                                     handleCopy,
                                                     handleDelete,
                                                     handlePerformance,
                                                     premium,
                                                   }) => (
  <Card sx={{ mb: '1rem' }}>
    <CardContent sx={{ display: 'flex', flexDirection: 'column', gap: '0.5rem', position: 'relative' }}>
      {/* Word count */}
      <Box sx={{ position: 'absolute', top: '1.3rem', left: '1rem', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
        <Tooltip title={<FormattedMessage id="home.text-generator.Result.wordcount" />} arrow>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
            <Typography
              variant="body2"
              color="textSecondary"
              sx={{ fontSize: { xs: '0.75rem', sm: '0.875rem' } }}
            >
              {countWords(response)} <FormattedMessage id="home.text-generator.Result.word" />
            </Typography>
          </Box>
        </Tooltip>
      </Box>

      {/* Buttons (Copy and Delete) */}
      <Box sx={{ position: 'absolute', top: '0.5rem', right: '0.5rem', display: 'flex', gap: '0.5rem' }}>
        {!premium ? (
          <HtmlTooltip
            title={
              <React.Fragment>
                <Typography variant="body2" color="inherit"><CrownIcon />
                  <FormattedMessage id="home.textarea.plagiarismChecker" />

                </Typography>
                <Typography variant="body2" color="textSecondary">
                  <FormattedMessage id="home.text-generator.premium" /></Typography>
                <Link href="#" color="primary" onClick={(e) => {
                  e.preventDefault();  // Prevent the default behavior (which is navigating to a URL)
                  gotoLogin();         // Call the gotoLogin function
                }}>                  <FormattedMessage id="home.text-generator.signupnow" /></Link>
              </React.Fragment>
            }
          >
                          <span>
                            <IconButton disabled color="primary"   sx={{
                              ':hover': { backgroundColor: 'transparent' }, // Removes hover background
                            }}>
                              <DocumentScannerIcon />
                            </IconButton>
                          </span>
          </HtmlTooltip>
        ) : (
          <IconButton color="primary" onClick={() => handlePerformance('Some text')}  sx={{
            ':hover': { backgroundColor: 'transparent' }, // Removes hover background
          }}>
            <BarChartIcon />
          </IconButton>
        )}

        <Tooltip title={<FormattedMessage id="home.text-generator.copy" />} arrow>
          <IconButton color="primary" onClick={() => handleCopy(response)}  sx={{
            ':hover': { backgroundColor: 'transparent' }, // Removes hover background
          }}>
            <ContentCopyIcon />
          </IconButton>
        </Tooltip>
        <Tooltip title={<FormattedMessage id="home.text-generator.delete" />} arrow>
          <IconButton color="primary" onClick={() => handleDelete(index, responses, setResponses)}  sx={{
            ':hover': { backgroundColor: 'transparent' }, // Removes hover background
          }}>
            <DeleteIcon />
          </IconButton>
        </Tooltip>
      </Box>

      {/* Editable response text */}
      <ResultField value={response} index={index} responses={responses} setResponses={setResponses} />
    </CardContent>
  </Card>
);

export default ResponseCardPlagiarism;
